import { registerStoreModuleAsync } from 'Store';

export default [
  {
    path: '/profile/my-advisors',
    name: 'my-advisors',
    component: () => import(/* webpackChunkName: 'PageMyAdvisors' */ '../PageMyAdvisors'),
    async beforeEnter(to, from, next) {
      const modulePromises = [];
      modulePromises.push(registerStoreModuleAsync('myAdvisors'));
      await Promise.all(modulePromises);
      next();
    },
    meta: {
      requiresAuth: true,
      store: [
        'myAdvisors/loadAdvisorsList',
      ],
    },
  },
];
